// fontawesome 6 - https://docs.fontawesome.com/apis/javascript/get-started
// https://docs.fontawesome.com/apis/javascript/configuration
import { library, dom, config } from '@fortawesome/fontawesome-svg-core';

import { fas } from '@fortawesome/free-solid-svg-icons'; 
import { far } from '@fortawesome/free-regular-svg-icons'; 
import { fab } from '@fortawesome/free-brands-svg-icons';

library.add(fas, far, fab);

config.autoA11y = true;
config.autoReplaceSvg = 'nest';

(function () {
    // the fa-stack stuff doe not wotk with the way the scripts 
    // are loaded into the head tag on legacy
    if ($('body').not('.legacy-master').length) {
        // Run the SVG replacement on modern pages
        dom.watch();
    } else {
        // Icons will fall back to the stable Web Font method.
    }
})();